<template>
  <div class="container">
    <div class="gene-block">
      <div class="gene" title="Gene">
        {{ props.alt.gene }}
      </div>
      <div title="Alteration">
        {{ props.alt.alteration }}
      </div>
    </div>
    <div class="trials-block">
      <span class="treatment" @click="onTreatmentsClicked" :class="{ 'selected': treatmentsSelected }">
        <span class="material-symbols-outlined size-24 unchecked" :class="{ 'selected': treatmentsSelected }"
          title="Treatments">
          pill
        </span>
        <div class="count">
          {{ props.alt.treatmentsCount }}
        </div>
      </span>
      <span class="trial" @click="onTrialsClicked" :class="{ 'selected': trialsSelected }">
        <span class="material-symbols-outlined size-24 unchecked" :class="{ 'selected': trialsSelected }" title="Trials">
          medical_information
        </span>
        <div class="count">
          {{ props.alt.trialsCount }}
        </div>
      </span>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { computed, defineProps, watch, ref } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const props = defineProps({
  gene: String,
  alteration: String,
  exon: String,
  treatmentsCount: Number,
  trialsCount: Number,
  alt: Object,
})

const treatmentsSelected = ref(false)
const trialsSelected = ref(false)

const genomicsResults = computed(() => store.getters.session?.genomicsResults || {})

const onTreatmentsClicked = () => {
  const cardState = {
    sampleId: genomicsResults.value.sampleId || '',
    diagnosis: genomicsResults.value.diagnosis || '',
    //specimen type, testType, labName probably need to go here as well
    selectedAlteration: props.alt.originalAlt || '',
    treatmentOrTrialType: 'treatments',
    treatmentOrTrialCount: props.alt.treatmentsCount,
  }
  store.dispatch('setGenomicsResults', { genomicsResults: cardState, publish: true })
}

const onTrialsClicked = () => {
  const cardState = {
    sampleId: genomicsResults.value.sampleId || '',
    diagnosis: genomicsResults.value.diagnosis || '',
    //specimen type, testType, labName probably need to go here as well
    selectedAlteration: props.alt.originalAlt || '',
    treatmentOrTrialType: 'trials',
    treatmentOrTrialCount: props.alt.trialsCount,
  }
  store.dispatch('setGenomicsResults', { genomicsResults: cardState, publish: true })
}

watch(genomicsResults, () => {
  if (genomicsResults.value.selectedAlteration !== props.alt.originalAlt) {
    treatmentsSelected.value = false
    trialsSelected.value = false
    return
  }
  if (genomicsResults.value.treatmentOrTrialType === 'treatments') {
    treatmentsSelected.value = true
    trialsSelected.value = false
    return
  }
  treatmentsSelected.value = false
  trialsSelected.value = true
})

</script>

<style lang="scss" scoped>
.gene {
  font-size: 80%;
  color: var(--Grey700);
}

.container {
  display: flex;
  margin: 0 0 35px 35px;
  background-color: #fefefe;
  align-items: center;
}

.gene-block {
  display: flex;
  flex-direction: column;
  margin-left: 5%;
  text-align: left;
  min-width: 100px;
  max-width: 215px;
  overflow-wrap: break-word;
}

.selected {
  color: var(--Primary);
  font-weight: 700;
  font-style: bold;

  font-variation-settings:
    'FILL' 1,
    'wght' 400,
    'GRAD' 0,
    'opsz' 48;
}

.trials-block {
  display: flex;
  flex-direction: row;
  color: var(--Grey500);
  text-align: left;
  align-items: flex-start;
  justify-content: flex-start;
}

.treatment {
  display: flex;
  flex-direction: row;
  margin-right: 40px;
  min-width: 40px;
  text-align: left;
  align-items: center;
  user-select: none;

  cursor: pointer;

  &:hover {
    color: var(--Grey700);
  }
}

.trial {
  display: flex;
  flex-direction: row;
  margin-right: 10px;
  text-align: left;
  align-items: center;
  user-select: none;

  cursor: pointer;

  &:hover {
    color: var(--Grey700);
  }
}

.count {
  margin-left: 3px;
}
</style>
